import constants from '@/constants';

import type { EditorAPI } from '@/editorAPI';

export const closeAddPagePanel = (editorAPI: EditorAPI) =>
  editorAPI.panelManager.closePanelByName(
    constants.PANEL_NAMES.ADD_PAGES_PANEL,
  );
